"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var downloadBar = require("../../../../psp_driverdetails/src/DLM");
var translates = l.Translator.translate;
var InstallTVSUPopupModel = /** @class */ (function () {
    function InstallTVSUPopupModel() {
        this.visible = false;
    }
    return InstallTVSUPopupModel;
}());
exports.InstallTVSUPopupModel = InstallTVSUPopupModel;
var InstallTVSUPopup = /** @class */ (function (_super) {
    __extends(InstallTVSUPopup, _super);
    function InstallTVSUPopup(props) {
        return _super.call(this, props) || this;
    }
    InstallTVSUPopup.prototype.render = function () {
        var model = this.props;
        if (model.visible === true) {
            if (model.downloadList != null && model.downloadList.length != null && model.downloadList.length > 0) {
                var itemDownloading = model.downloadList[0];
                var idx = $.inArray(itemDownloading, model.downloadList);
                var downloadProcessBarModel = downloadBar.GetDownloadProgressInfo(itemDownloading, idx, model.downloadList.length);
                return React.createElement("div", null,
                    React.createElement("div", { className: "dow-adup-result-dialog-box dow-adup-install-tvsu-result" },
                        React.createElement("div", { className: "downloadProgress" },
                            React.createElement("span", { className: "dow-adup-h3" }, translates('Download in Progress')),
                            React.createElement(downloadBar.DownloadProgressBar, { "data-downloadProgressInfo": downloadProcessBarModel }),
                            React.createElement("div", { className: "dow-adup-install-tvsu-buttons" },
                                React.createElement("a", { className: "dow-adup-button blue", onClick: model.cancelInstallTVSUHandler }, translates('Cancel'))),
                            React.createElement("br", null))),
                    React.createElement("div", { className: "dow-adup-load" }));
            }
        }
        return null;
    };
    return InstallTVSUPopup;
}(React.Component));
exports.InstallTVSUPopup = InstallTVSUPopup;
